import { Module } from 'vuex';
import { RootState } from 'frontend/types';

interface TyuExperienceConfig {
  show_tyu_experience: boolean;
  is_lesson_in_tyu_experiment: boolean;
  nextEndstateNeedsTyuOutro?: boolean;
}

const tyuExperienceConfig: Module<TyuExperienceConfig, RootState> = {
  namespaced: true,
  state: {
    show_tyu_experience: false,
    is_lesson_in_tyu_experiment: false,
    nextEndstateNeedsTyuOutro: false,
  },
  getters: {
    showTYUExperience: (state: TyuExperienceConfig): boolean => state.show_tyu_experience,
    isLessonInTyuExperiment: (state: TyuExperienceConfig): boolean =>
      state.is_lesson_in_tyu_experiment,
    nextEndstateNeedsTyuOutro: (state: TyuExperienceConfig): boolean =>
      state.nextEndstateNeedsTyuOutro === true,
  },
  mutations: {
    setValue(state: TyuExperienceConfig, value: TyuExperienceConfig): void {
      Object.assign(state, value);
    },
    setNextEndstateNeedsTYUOutro(state: TyuExperienceConfig, value: boolean) {
      state.nextEndstateNeedsTyuOutro = value;
    },
  },
  actions: {
    setNextEndstateNeedsTYUOutro({ commit }, value: boolean) {
      commit('setNextEndstateNeedsTYUOutro', value);
    },
  },
};

export default tyuExperienceConfig;
